export default {
  items({ items }) {
    return items;
  },
  serverItemsLength({ serverItemsLength }) {
    return serverItemsLength;
  },
  selected({ selected }) {
    return selected;
  },
  dispute({ dispute }) {
    return dispute;
  },
  disputeReasons({ disputeReasons }) {
    return disputeReasons.map((reason) => ({ name: reason, id: reason }));
  },
  flatDisputeReasons({ disputeReasons }) {
    return disputeReasons;
  },
};
